import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import CreateTaskTitleLabel from 'automation-ui-action-features/actions/create-task/CreateTaskTitleLabel';
import CreateTaskOwnerLabel from 'automation-ui-action-features/actions/create-task/CreateTaskOwnerLabel';
import { jsx as _jsx } from "react/jsx-runtime";
function CreateTaskActionDetail({
  actionMetadata,
  messageLangPath = 'actionDetail',
  flowObjectTypeId
}) {
  const options = {
    owner: /*#__PURE__*/_jsx(CreateTaskOwnerLabel, {
      actionMetadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId
    }),
    subject: /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(CreateTaskTitleLabel, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    })
  };
  return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.create-task.action-detail",
    options: options
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.create-task.action-preview",
    options: options
  });
}
export default CreateTaskActionDetail;